// ALW-105139: only the 3 pipeline-resolved magic links convert `#{...}#` → `{$...}`
// on editor load; real custom fields keep legacy form. No DB batch migration.

// Longest literal first so the profile-link tag can never be partially rewritten.
const LEGACY_TO_CURRENT = [
  ['#{unsubscribeProfileLink}#', '{$unsubscribeProfileLink}'],
  ['#{unsubscribeLink}#', '{$unsubscribeLink}'],
  ['#{browser_link}#', '{$browser_link}'],
];

/**
 * @param {string} value - Template HTML, JSON blob, or token-bearing fragment.
 * @returns {string} Same string with only the 3 whitelisted tags in `{$...}` form.
 */
const convertString = (value) =>
  LEGACY_TO_CURRENT.reduce(
    (acc, [legacy, current]) => acc.split(legacy).join(current),
    value,
  );

/**
 * Recursively convert legacy magic tags in loaded template content (string,
 * JSON string, component object/array, or nullish). Idempotent on re-entry.
 * @param {*} value - Content from the API as received by the two load paths.
 * @returns {*} Same shape; only the 3 whitelisted tags replaced, everything else as-is.
 */
export const convertLegacyMergeTags = (value) => {
  if (typeof value === 'string') {
    return convertString(value);
  }

  if (Array.isArray(value)) {
    return value.map(convertLegacyMergeTags);
  }

  if (value && typeof value === 'object') {
    return Object.entries(value).reduce((acc, [key, entry]) => {
      acc[key] = convertLegacyMergeTags(entry);

      return acc;
    }, {});
  }

  return value;
};
